export const buyers = [
  { name: "Dr. Alejandro M.", country: "Mexico", time: "2 minutes ago" },
  { name: "Dr. Valentina R.", country: "Colombia", time: "4 minutes ago" },
  { name: "Dr. Martín G.", country: "Argentina", time: "just now" },
  { name: "Dr. Lucía F.", country: "Spain", time: "6 minutes ago" },
  { name: "Dr. Sebastián P.", country: "Chile", time: "3 minutes ago" },
  { name: "Dr. Camila T.", country: "Peru", time: "8 minutes ago" },
  { name: "Dr. Diego A.", country: "Ecuador", time: "1 minute ago" },
  { name: "Dr. Gabriela S.", country: "Dominican Republic", time: "5 minutes ago" },
  { name: "Dr. Andrés L.", country: "Costa Rica", time: "7 minutes ago" },
  { name: "Dr. Mariana C.", country: "Uruguay", time: "2 minutes ago" },
  { name: "Dr. Javier O.", country: "Venezuela", time: "9 minutes ago" },
  { name: "Dr. Daniela V.", country: "Puerto Rico", time: "just now" },
  { name: "Dr. Ricardo H.", country: "Guatemala", time: "4 minutes ago" },
  { name: "Dr. Sofía B.", country: "Panama", time: "3 minutes ago" },
];
